/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Recent_SharesInputs */

const en_no_recent_shares = /** @type {(inputs: No_Recent_SharesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No recent sharing history.`)
};

const es_no_recent_shares = /** @type {(inputs: No_Recent_SharesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay historial de uso compartido reciente.`)
};

const fr_no_recent_shares = /** @type {(inputs: No_Recent_SharesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun historique de partage récent.`)
};

const de_no_recent_shares = /** @type {(inputs: No_Recent_SharesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein aktueller Freigabeverlauf.`)
};

const id_no_recent_shares = /** @type {(inputs: No_Recent_SharesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada riwayat berbagi baru-baru ini.`)
};

/** @type {(inputs: No_Recent_SharesInputs) => LocalizedString} */
const ja_no_recent_shares = en_no_recent_shares;

/** @type {(inputs: No_Recent_SharesInputs) => LocalizedString} */
const zh_no_recent_shares = en_no_recent_shares;

/** @type {(inputs: No_Recent_SharesInputs) => LocalizedString} */
const ar_no_recent_shares = en_no_recent_shares;

/** @type {(inputs: No_Recent_SharesInputs) => LocalizedString} */
const it_no_recent_shares = en_no_recent_shares;

/** @type {(inputs: No_Recent_SharesInputs) => LocalizedString} */
const ru_no_recent_shares = en_no_recent_shares;

/** @type {(inputs: No_Recent_SharesInputs) => LocalizedString} */
const pt_no_recent_shares = en_no_recent_shares;

/** @type {(inputs: No_Recent_SharesInputs) => LocalizedString} */
const ko_no_recent_shares = en_no_recent_shares;

/**
* | output |
* | --- |
* | "No recent sharing history." |
*
* @param {No_Recent_SharesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const no_recent_shares = /** @type {((inputs?: No_Recent_SharesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Recent_SharesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_recent_shares(inputs)
	if (locale === "es") return es_no_recent_shares(inputs)
	if (locale === "fr") return fr_no_recent_shares(inputs)
	if (locale === "de") return de_no_recent_shares(inputs)
	if (locale === "ja") return ja_no_recent_shares(inputs)
	if (locale === "zh") return zh_no_recent_shares(inputs)
	if (locale === "ar") return ar_no_recent_shares(inputs)
	if (locale === "id") return id_no_recent_shares(inputs)
	if (locale === "it") return it_no_recent_shares(inputs)
	if (locale === "ru") return ru_no_recent_shares(inputs)
	if (locale === "pt") return pt_no_recent_shares(inputs)
	return ko_no_recent_shares(inputs)
});